import { commonFooterLinks } from '@/vue/common/footer/config';
export const footerLinks = (t) => [
    ...commonFooterLinks(t),
    {
        label: 'Acclym.com',
        link: t('footer.links.home_page', 0, { redirectorUrl: window.location.href }),
    },
];
